import React from 'react';
import { FeedBackScreen } from './container';

export const FeedbackScreenView = ({ navigation }: { navigation: any }) => {
    return <FeedBackScreen />
}